import type { ApprovalChain } from '../approval-chain.model';

export const LAND_TENURE_DEED_OF_GRANT_CHAIN: ApprovalChain = {
  id: 'land-tenure-deed-of-grant',
  label: 'Land Tenure Deed of Grant (Ministry of Lands route)',
  applicationTypes: ['LAND_TENURE_DEED_OF_GRANT', 'LAND_TENURE_DEED_OF_GRANT_BOND'],
  archive: { role: 'MINISTER_OF_LANDS_TECHNICIAN', from: ['SUBMITTED', 'QUERIED', 'RESUBMITTED'] },
  steps: [
    { role: 'MINISTER_OF_LANDS_TECHNICIAN', action: 'Recommend', from: ['SUBMITTED', 'PENDING_REVIEW', 'RESUBMITTED'], to: 'MINISTRY_OF_LANDS_TECHNICIAN_RECOMMENDED' },
    { role: 'MINISTER_OF_LANDS_DIRECTOR', action: 'Recommend', from: ['MINISTRY_OF_LANDS_TECHNICIAN_RECOMMENDED'], to: 'MINISTRY_OF_LANDS_DIRECTOR_APPROVED' },
    { role: 'MINISTER_OF_LANDS_DIRECTOR_LEGAL', action: 'Approve', from: ['MINISTRY_OF_LANDS_DIRECTOR_APPROVED'], to: 'MINISTRY_OF_LANDS_DIRECTOR_LEGAL_APPROVED' },
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['MINISTRY_OF_LANDS_DIRECTOR_LEGAL_APPROVED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Approve', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_APPROVED' },
    { role: 'SURVEYOR_GENERAL_TECHNICIAN', action: 'Recommend', from: ['REGISTRAR_APPROVED'], to: 'SG_TECHNICIAN_RECOMMENDED' },
    { role: 'SURVEYOR_GENERAL', action: 'Approve', from: ['SG_TECHNICIAN_RECOMMENDED'], to: 'APPROVED' },
  ],
};
